import { FC } from 'react';
import { Redirect, Route } from 'react-router';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { CaregiverHomePage } from '../home/CaregiverHomePage';
import { InsightsPageRouteHandler } from '../insights/InsightsPage';
import { OnboardingPageRouteHandler } from '../onboarding/OnboardingPage';
import { OrganizationsState } from '../organizations/OrganizationsState';
import { AgencyHomePage } from '../organizations/AgencyHomePage';
import { AGENCY_TAB_ROUTE, isAgencyTab } from '../organizations/agencyTabs';

export const CaregiverRouter: FC = () => {
    const orgsState = useInstance(OrganizationsState);
    useSubscription(() => orgsState);

    return (
        <>
            <Route exact path="/caregiver/daily-log" render={() => {
                return <Redirect to={'/calendar/journal/daily-log'} />;
            }} />

            <InsightsPageRouteHandler />
            <OnboardingPageRouteHandler />

            {/* One route for home and the agency tabs, so the agency home stays mounted through its landing. */}
            <Route exact path={['/caregiver', AGENCY_TAB_ROUTE]} render={(props) => {
                const { tab } = props.match.params;
                const careMapId = new URLSearchParams(props.location.search).get('id') || undefined;

                if (orgsState.isOrgTeamMember()) {
                    return <AgencyHomePage tab={isAgencyTab(tab) ? tab : undefined} search={props.location.search} careMapId={careMapId} />;
                }

                if (tab) {
                    return <Redirect to="/caregiver" />;
                }

                return <>
                    <CaregiverHomePage careMapId={careMapId}/>
                </>;
            }} />
        </>
    );
};
